import React, { Component } from "react";
import { Form, Layout, Button, Row, Col, Popconfirm, Table, Tag } from "antd";
import "./index.scss";
import CreateUpdateModal from "./components/CreateUpdateModal";
import { checkPermission } from "../../utils/helper";
import { Redirect } from "react-router-dom";

const { Content } = Layout;

class Ticket extends Component {
  initialState = {
    ticketsData: [],
    showCreateUpdateModal: false,
    selectedRow: {}
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  handleCreateButton = () => {
    this.setState({
      showCreateUpdateModal: true
    });
  };

  handleUpdateButton = (row) => {
    this.setState({
      showCreateUpdateModal: true,
      selectedRow: row
    });
  };

  handleDeleteButton = (row) => {
    this.props.onDeleteTicket(row);
  }

  handleCloseModal = () => {
    this.setState({
      showCreateUpdateModal: false,
    });
  };

  componentDidMount() {
    const onGetParam = {
      event_id: this.props.event.id
    };
    this.props.onGetTickets(onGetParam);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ticketsData !== nextProps.ticketsData) {
      this.setState({ ticketsData: nextProps.ticketsData });
    }
  }

  render() {
    const { ticketsData, showCreateUpdateModal, selectedRow } = this.state;
    const { isLoading, } = this.props;
    const module = "ticket";

    if (!checkPermission(module, "view")) {
      return (<Redirect to="/403" />);
    }

    const columns = [
      {
        title: 'Ticket Name',
        dataIndex: 'ticket_name',
        key: 'ticket_name',
      },
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'type',
        align: 'center',
      },
      {
        title: 'Count',
        dataIndex: 'issue_count',
        key: 'issue_count',
        align: 'right',
      },
      {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
        align: 'right',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        render: status => (
          <span>
            {status == 1 ?
              (
                <Tag color='green' key='active'>
                  Active
                </Tag>
              ) : (
                <Tag color='gray' key='inactive'>
                  Inactive
                </Tag>
              )
            }
          </span>
        ),
      },
      {
        title: 'Action',
        key: 'action',
        align: 'center',
        render: (text, record) => (
          <span>
            {(checkPermission(module, "edit")) ?
              <Button type="default" onClick={() => this.handleUpdateButton(record)}>Edit</Button> : ''
            }
            &nbsp;&nbsp;
            {/* <Divider type="vertical" /> */}
            {(checkPermission(module, "delete")) ?
              <Popconfirm
                title="Are you sure you want to delete?"
                onConfirm={() => this.handleDeleteButton(record)}
                okText="Proceed"
                cancelText="Cancel"
              >
                <Button type="danger">Delete</Button>
              </Popconfirm> : ''
            }
          </span>
        ),
      },
    ];

    return (
      <Layout className="ticket-container">
        <Content className="ticket-content" style={{ padding: "20px 60px" }}>
          <Row type="flex" gutter={30}>
            <Col span={24}>
              <h2>Tickets</h2>
            </Col>
          </Row>

          <Row type="flex" gutter={30}>
            <Col span={12} className="page-content-control-button-holder">
              {(checkPermission(module, "create")) ?
                <Button type="primary" loading={isLoading} onClick={this.handleCreateButton}>Add Ticket</Button> : ''
              }
            </Col>
          </Row>

          <Row type="flex" gutter={30}>
            <Col span={24}>
              <Table columns={columns} dataSource={ticketsData} loading={isLoading} rowKey={"id"} />
            </Col>
          </Row>
        </Content>

        <CreateUpdateModal showModal={showCreateUpdateModal} selectedRow={selectedRow} handleCloseModal={this.handleCloseModal} {...this.props} />
      </Layout>
    );
  }
}

const TicketForm = Form.create({ name: "ticket-form" })(Ticket);

export default TicketForm;
